import React, { forwardRef } from "react";
import ApartmentIcon from "@mui/icons-material/Apartment";
import { ReactComponent as Logo } from "../icons-svg/icons/Otis_logo_white.svg";
import "./InspectionReport.scss";

const InspectionReport = forwardRef(
    (
        {
            siteId,
            components,
            reportData,
            printDate,
        },
        ref
    ) => {
        return (
            <div
                ref={ref}
                className="inspection-report"
            >
                <div className="print-page-header" aria-hidden="true">
                    <Logo />
                    <div className="print-page-title-block">
                        <span className="print-page-company">OTIS</span>
                        <h2>Site Inspection Report</h2>
                        <div className="site-details-print-title">
                            <ApartmentIcon />
                            <span style={{ color: '#1f2937' }}>Grand Central Site ID </span>
                            <span style={{ marginLeft: '0.2rem', color: '#1976d2', fontWeight: 600 }}>
                            {siteId}
                        </span>
                        </div>
                    </div>
                </div>

                {components.map((component) => {
                    const compId = component.component_type;
                    return (
                        <div
                            key={compId}
                            className="report-component"
                        >
                            <div className="component-brief">
                                <div>{component.component_type}</div>
                                <div>Amount of Devices  : <strong>{component.amount_device}</strong></div>
                                <div>Amount of unique SW version  : <strong>{component.amount_unique_version}</strong></div>
                                <div>Last SW Update  : <strong>{component.software_update_date}</strong></div>
                            </div>

                            <div className="print-legend">
                                <div className="legend-item"><span className="legend-dot mismatch"></span> Components not on latest SW Release</div>
                            </div>

                            <table className="print-table">
                                <thead>
                                    <tr>
                                        <th>Local Site ID</th>
                                        <th>Hardware ID</th>
                                        <th>Component Type</th>
                                        <th>Current SW Version</th>
                                        <th>Most Recent SW Version</th>
                                        <th>Most Recent Release Date</th>
                                        <th>Last SW Update</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {(reportData && reportData[compId] ? reportData[compId] : []).map(
                                        (row) => {
                                            const current = row.current_sw_version;
                                            const recent = row.most_recent_sw_version;
                                            const equal = current != null && recent != null && String(current) === String(recent);
                                            const textColor = equal ? '#2e7d32' : '#d32f2f';
                                            const cellInnerStyle = {
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                            };
                                            const dotStyle = {
                                                width: '10px',
                                                height: '10px',
                                                borderRadius: '50%',
                                                backgroundColor: equal ? '#4CAF50' : '#F44336',
                                                boxShadow: '0 0 0 2px rgba(0,0,0,0.03)',
                                                flex: '0 0 auto',
                                            };

                                            return (
                                                <tr key={row.local_site_id}>
                                                    <td>{row.local_site_id}</td>
                                                    <td>{row.hardware_id}</td>
                                                    <td>{row.component_type}</td>
                                                    <td style={{ color: textColor }}>
                                                        <div style={cellInnerStyle}>
                                                            <span style={dotStyle} aria-hidden="true" />
                                                            <span>{current ?? ''}</span>
                                                        </div>
                                                    </td>
                                                    <td>{row.most_recent_sw_version ?? ''}</td>
                                                    <td>
                                                        {row.recent_release_date}
                                                    </td>
                                                    <td>{row.last_sw_update}</td>
                                                </tr>
                                            )
                                        }
                                    )}
                                </tbody>
                            </table>
                        </div>
                    );
                })}

                <div className="report-footer">
                    Generated on {printDate}
                </div>
            </div>
        );
    }
);

export default InspectionReport;